const MENU_PREFIX = '@MENU';

export const FETCH = `${MENU_PREFIX}/FETCH_MENU`;
export const FETCH_SUCCESS = `${MENU_PREFIX}/FETCH_SUCCESS`;
export const FETCH_ERROR = `${MENU_PREFIX}/FETCH_ERROR`;

export const SET_IDLE = `${MENU_PREFIX}/SET_IDLE`;

export const SET_IS_VISIBLE = `${MENU_PREFIX}/SET_IS_VISIBLE`;
